import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context';
import { getDefaultLandingPath } from '../../utils/defaultLanding';

export const MonitorGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canMonitor } = useAuth();
  if (!canMonitor) {
    return <Navigate to={getDefaultLandingPath()} replace />;
  }
  return <>{children}</>;
};

export default MonitorGate;
